import { keepPreviousData } from '@tanstack/react-query';
import { useRepositoryQuery, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { WithAccountId, WithEnterpriseId } from '@mews-commander/types';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const useReservationsSearch = (onlyUnpaidReservations: boolean) => {
    const enterpriseId = useCurrentEnterpriseId();
    const useSearchQuery = (searchToken: string) =>
        useRepositoryQuery(
            'billing',
            'searchForReservationsForLinking',
            { searchToken, enterpriseId, onlyUnpaidReservations },
            { enabled: searchToken.length > 0, placeholderData: keepPreviousData }
        );
    return useSearchQuery;
};

export const useGetAllReservationsSuspense = ({ accountId }: WithAccountId) =>
    useRepositorySuspenseQuery(
        'reservations',
        'getAll',
        {
            accountIds: accountId ? [accountId] : [],
            extent: {
                accounts: true,
                reservationGroups: false,
                availabilityBlocks: false,
                companionships: false,
                orderItems: false,
                products: false,
                businessSegments: false,
                generalNotes: false,
                channelManagerNotes: false,
                vouchers: false,
                partnerCompanies: false,
                rates: false,
                specialRequestNotes: false,
                travelAgencies: false,
                origin: false,
                bookingEngines: false,
                purchaseOrderNumbers: false,
            },
        },
        { refetchOnMount: 'always' }
    );

export const useGetDefaultReservationsForLinkingSuspense = ({
    enterpriseId,
    accountId,
    showOnlyUnpaidReservations,
}: { showOnlyUnpaidReservations: boolean } & WithEnterpriseId & WithAccountId) =>
    useRepositorySuspenseQuery(
        'billing',
        'defaultReservationsForLinking',
        { enterpriseId, accountIds: [accountId], onlyUnpaidReservations: showOnlyUnpaidReservations },
        { refetchOnMount: 'always' }
    );
